import { useState } from "react";
import type { FidelityNote } from "../api/types";
import { AlertIcon, ChevronDownIcon } from "./Icon";

const TYPE_LABEL: Record<FidelityNote["type"], string> = {
  omission: "Omission",
  distortion: "Distortion",
  addition: "Addition",
  misattribution: "Misattribution",
};

export default function FidelityNotes({ notes }: { notes: FidelityNote[] }) {
  const [open, setOpen] = useState(false);
  if (notes.length === 0) return null;

  return (
    <div className="rounded-lg border border-warn-border bg-warn-surface">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2 text-sm font-medium text-warn">
          <AlertIcon width={16} height={16} />
          {notes.length} {notes.length === 1 ? "passage" : "passages"} may be imperfectly preserved
        </span>
        <ChevronDownIcon width={16} height={16} className={`shrink-0 text-warn transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open ? (
        <ul className="space-y-4 border-t border-warn-border px-4 py-3">
          {notes.map((note, i) => (
            <li key={i} className="text-sm">
              <div className="mb-1.5 flex flex-wrap items-center gap-2 text-xs">
                <span
                  className={
                    "rounded px-1.5 py-0.5 font-medium " +
                    (note.severity === "critical" ? "bg-danger-surface text-danger" : "bg-bg text-warn")
                  }
                >
                  {TYPE_LABEL[note.type]} · {note.severity}
                </span>
                <span className="text-muted">
                  Chapter {note.chapter} · {note.chapter_title}
                </span>
              </div>
              <blockquote className="border-l-2 border-warn-border pl-3 italic text-muted">“{note.source_quote}”</blockquote>
              <p className="mt-1.5 text-text">{note.detail}</p>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
